import PresidentAddressDesktopIcon from "@assets/president-address/president-address-logo-desktop.svg";
import PresidentAddressMobileIcon from "@assets/president-address/president-address-logo-mobile.svg";

type PresidentAddressIconProps = {
  isLive: boolean;
  variant?: "banner" | "heading";
};

export function PresidentAddressIcon({
  isLive,
  variant = "banner",
}: PresidentAddressIconProps) {
  const forBannerOnly = variant === "banner";

  return (
    <div className="flex items-center flex-col">
      {/* Desktop icon (only for banner) */}
      {forBannerOnly && (
        <img
          className="hidden lg:block"
          src={PresidentAddressDesktopIcon}
          alt="president-address-desktop"
          width={33}
          height={32}
        />
      )}

      {/* Mobile / heading icon */}
      <img
        className={forBannerOnly ? "lg:hidden" : ""}
        src={PresidentAddressMobileIcon}
        alt={isLive ? "live-icon" : "president-address-mobile"}
        width={isLive ? 43 : 44}
        height={isLive ? undefined : 44}
      />

      {/* Live badge */}
      {isLive && (
        <div
          className={`flex -mt-2.5 ${forBannerOnly ? "lg:-mt-3" : ""} gap-1 items-center bg-red-100 text-text-inverse px-1.5 w-[50px] h-[16px] box-border`}
          id="liveButton"
        >
          <div
            className="w-2 h-2 bg-bg-primary rounded-[50%] animate-blink"
            id="liveDot"
          ></div>
          <div className="font-bold text-xs leading-[24px]">Live</div>
        </div>
      )}
    </div>
  );
}
